// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"FieldNameCell-primaryButton-2-PtOi","fieldName":"FieldNameCell-fieldName-KastuG"};